import { func } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import withState from 'recompose/withState'
import withProps from 'recompose/withProps'
import withHandlers from 'recompose/withHandlers'

import objectEditorEnhancer from 'coact/objectEditorEnhancer'

import ScopeSettingView from './ScopeSetting'

const ScopeSetting = scope(
  consumeProps({
    updateScopeAndGridValues: func.isRequired,
  }),

  withState('value', 'onChange', { }),
  withProps({
    schema: {
      type: 'object',
      contents: {
        s1: { type: 'number' },
        s2: { type: 'number' },
        c1: { type: 'number' },
        c2: { type: 'number' },
      },
    },
  }),

  objectEditorEnhancer,

  withHandlers({
    changeScope: ({ value: { s1, s2, c1, c2 }, updateScopeAndGridValues }) => () =>
      updateScopeAndGridValues({
        sMax: Math.max(s1, s2) * 100,
        sMin: Math.min(s1, s2) * 100,
        cMax: Math.max(c1, c2) * 100,
        cMin: Math.min(c1, c2) * 100,
      }),
  }),

  exposeProps([
    'schema',
    'value',
    'onChange',
    'spliter',
    'changeScope',
  ]),
)(ScopeSettingView)

ScopeSetting.displayName = 'ScopeSetting'

export default ScopeSetting



// WEBPACK FOOTER //
// ./src/components/RangeEditor/ScopeSetting/index.js